import { Skeleton, VStack } from '@vidahealth/vida-ui';

import { SelectableRowSkeleton } from '@/modules/ui';

/**
 * Private to CoachMatchingScreen — loading placeholder for the matched-coaches
 * list while the (non-blocking) catalog fetch is in flight: a tall recommended
 * card, then a "More health experts" heading + a few compact rows.
 */
export function CoachListSkeleton() {
  return (
    <VStack space='lg'>
      <Skeleton variant='rounded' className='h-[280px] w-full' />
      <Skeleton variant='rounded' className='mt-2 h-4 w-44' />
      <SelectableRowSkeleton variant='avatar_and_text' count={3} rowHeight={120} />
    </VStack>
  );
}
